import { container_classname } from "@components/new-ui/constants";
import CTAButtons from "@components/new-ui/CTAButtons";
import Image from "next/image";

export interface CTASectionProps {
    content: string;
    imageUrl: string;
    imgAlt: string;
    btnText: string;
}

const blueCardCTAContent: CTASectionProps = {
    content: "Close deals in record time with WhatsApp automation",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/sales-cta.png",
    imgAlt: "wa-gallabox",
    btnText: "Read the story",
};

const greyCardCTAContent: CTASectionProps = {
    content: "Numberwale increased their sales by 25% with Gallabox",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/numberwale.png",
    imgAlt: "wa-gallabox",
    btnText: "Read the story",
};

export const BlueCardCTASection: React.FC<{ ctaContent?: CTASectionProps }> = ({ ctaContent = blueCardCTAContent }) => {
    const { content, imageUrl, imgAlt, btnText } = ctaContent;
    return (
        <section
            className={`${container_classname} text-white p-5 rounded-md flex  md:items-center justify-between md:flex-row flex-col-reverse`}
            style={{
                background: "linear-gradient(265deg, #A1D8FF -7.73%, #396AFF 19.04%, #00238D 61.31%, #000 102.16%",
            }}
        >
            <div className="flex flex-col gap-6">
                <h6 className="text-4xl">{content}</h6>
                <CTAButtons variant="secondary-light" primaryButtonText={btnText} />
            </div>
            <Image src={imageUrl} alt={imgAlt} width={175} height={175} className="md:w-fit w-full" />
        </section>
    );
};

export const GreyCardCTASection: React.FC<{ ctaContent?: CTASectionProps; urlLink?: string }> = ({ ctaContent = greyCardCTAContent, urlLink = "https://www.numberwale.com/" }) => {
    const { content, imageUrl, imgAlt, btnText } = ctaContent;
    return (
        <section
            className={`${container_classname} text-black p-5 rounded-md flex  md:items-center gap-10 md:flex-row flex-col`}
            style={{
                background: "linear-gradient(103deg, #EDF4FF 28.71%, #D2DDFF 84.45%, #84A2FF 136.43%)",
            }}
        >
            <Image src={imageUrl} alt={imgAlt} width={175} height={175} className="md:w-fit w-full" />
            <div className="flex flex-col gap-6">
                <h6 className="text-4xl">{content}</h6>
                <CTAButtons variant="primary-light" primaryButtonText={btnText} urlLink={urlLink} />
            </div>
        </section>
    );
};
